<template>
  <kd-layout-fixed-bottom-button button-text="撤回请假" @click="cancelLeave" class="ask-for-leave-records-page">
    <div class="apply-info">
      <div class="header">{{ applyTitle }} <apply-status-tag :status="status" /></div>

      <div class="approval-information">
        <div class="title">审批信息</div>

        <div class="item">
          <div class="label">所在班级</div>
          <div class="info">
            {{
              item.clazz.enrollment_year
                ? item.clazz.enrollment_year.toString().slice(2) + '级' + item.clazz.note_name
                : item.clazz.note_name || item.clazz.name
            }}
          </div>
        </div>

        <div class="item">
          <div class="label">请假原因</div>
          <div class="info">
            {{ item.items[1].value }}
          </div>
        </div>

        <div class="item">
          <div class="label">发起时间</div>
          <div class="info">
            {{ createTime }}
          </div>
        </div>

        <div class="item">
          <div class="label">请假时间</div>
          <div class="info">
            {{ item.items[2].value }} (共 <span>{{ durations }}</span> 天)
          </div>
        </div>

        <div class="item">
          <div class="label">附件</div>
          <div class="info">
            <image-popup
              :width="$px(44)"
              :height="$px(44)"
              v-for="(imgUrl, index) in item.attachments"
              :img-url="imgUrl"
              :key="index"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="reject-box" v-if="status === 'rejected'">
      <div class="header">拒绝原因</div>
      <div class="content">{{ item.rejected_reason }}</div>
    </div>

    <template #footer>
      <div class="buttons">
        <div class="reject btn" @click="openRejectDialog">
          <img src="./assets/img_reject@2x.png" />
          拒绝
        </div>
        <div class="pass btn" @click="pass">
          <img src="./assets/img_pass@2x.png" />
          通过
        </div>
      </div>
    </template>
    <kd-popup class="reject-popup" :hide-title="true" :visible.sync="rejectDialogVisible" position="center">
      <div class="header">确认拒绝该审批吗？</div>
      <kd-input placeholder="请填写审批意见（非必填）" :rows="5" v-model="reason"> </kd-input>

      <div class="buttons">
        <kd-button class="cancel" @click="rejectDialogVisible = false">取消</kd-button>
        <kd-button class="reject" @click="reject">确认拒绝</kd-button>
      </div>
    </kd-popup>
  </kd-layout-fixed-bottom-button>
</template>
<script lang="ts">
import { BasePage, Component, ApplyStatusTag, Prop, ImagePopup } from 'kuaidong-component'
import { KdLayoutFixedBottomButton, KdPopup, KdInput, KdButton } from 'kuaidong-ui'
import { DateWrapper } from 'kuaidong-lib'
import { IStudentLeaveRecordItem } from 'kuaidong-model/src/approvalLeave'
import differenceInDays from 'date-fns/differenceInDays'
import { AApprovalLeave } from 'kuaidong-api'

@Component({
  components: {
    KdLayoutFixedBottomButton,
    ApplyStatusTag,
    KdPopup,
    KdInput,
    KdButton,
    ImagePopup,
  },
})
export default class AskForLeaveDetailsPage extends BasePage {
  @Prop({ type: Object, required: true })
  item!: IStudentLeaveRecordItem & {
    name: string
    title: string
    items: Record<string, string>[]
  }

  reason = ''
  rejectDialogVisible = false
  operation = this.item.status
  get isUnProcess() {
    return this.item.status === 'pending'
  }

  get applyTitle() {
    return `${this.item.title}同学的请假申请`
  }

  get status() {
    return this.operation
  }

  get createTime() {
    return new DateWrapper(this.item.created_time).showStrFullDate
  }

  get durations() {
    return this.getDaysBetween(this.item.start_time, this.item.end_time) + 1
  }

  getDaysBetween(start: string, end: string) {
    return differenceInDays(new Date(end), new Date(start))
  }

  cancelLeave() {
    this.toast('撤回请假')
    return
  }

  openRejectDialog() {
    this.rejectDialogVisible = true
  }

  async reject() {
    try {
      await AApprovalLeave.rejectLeave(this.item.id, this.reason)
      this.toast('审批已拒绝~')
      this.operation = 'rejected'
    } catch (e) {
      this.toast('审批拒绝发生错误~')
    }
    this.rejectDialogVisible = false
  }

  async pass() {
    try {
      await AApprovalLeave.approveLeave(this.item.id)
      this.toast('审批已通过~')
      this.operation = 'approved'
    } catch (e) {
      this.toast('审批通过发生错误~')
    }
  }
}
</script>
<style lang="less">
.ask-for-leave-records-page {
  > .kd-layout-fixed-bottom__main {
    > .apply-info {
      display: flex;
      flex-direction: column;
      padding: 22px 16px;

      background: #fff;

      > .header {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
        color: #000000;
        padding-bottom: 16px;
        border-bottom: 1px solid #f5f5f5;
        > .apply-status-tag-comp {
          margin-left: 4px;
        }
      }

      > .approval-information {
        margin-top: 16px;

        > .title {
          font-weight: 500;
          font-size: 16px;
          line-height: 16px;
          color: #2d2f33;
          text-align: left;
        }
        > .item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 24px;
          > .label {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #8f8f8f;
          }
          > .info {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #4d4d4d;
            display: flex;

            > span {
              color: #3366ff;
            }
            > .image-popup-comp {
              margin-left: 12px;
              border-radius: 4px;
            }
          }
        }
      }
    }

    > .reject-box {
      margin-top: 8px;
      padding: 16px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;

      > .header {
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        color: #2d2f33;
      }

      > .content {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #b8b8b8;
        margin-top: 16px;
        text-align: left;
      }
    }

    > .reject-popup {
      > .kd-popup__main {
        border-radius: 16px;

        > .kd-popup__content {
          width: 306px;
          background: #ffffff;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.196815);
          border-radius: 16px;
          padding: 25px 16px;
          box-sizing: border-box;
          > .header {
            font-weight: 600;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            color: #2d2f33;
          }
          > .kd-input {
            margin-top: 12px;
            background: #f7f8fa;
            border: 1px solid #e5e5e5;
            border-radius: 8px;
          }
          > .buttons {
            display: flex;
            justify-content: center;
            margin-top: 30px;
            > .cancel {
              background: #f8f8f8;
              border-radius: 22px;
              font-weight: 500;
              font-size: 15px;
              line-height: 21px;
              text-align: center;
              color: #4d4d4d;
            }
            > .reject {
              background: #f24b53;
              border-radius: 22px;
              font-weight: 500;
              font-size: 15px;
              line-height: 21px;
              text-align: center;
              color: #ffffff;
              margin-left: 14px;
            }
          }
        }
      }
    }
  }

  > .kd-layout-fixed-bottom__footer {
    padding: 15px 25px;
    > .buttons {
      display: flex;
      justify-content: space-between;
      > .btn {
        background: #ffffff;
        border-radius: 8px;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 1px;
        height: 44px;
        width: 160px;
        display: flex;
        align-items: center;
        justify-content: center;
        > img {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
        &.reject {
          border: 1px solid #f24b53;
          color: #f24b53;
        }
        &.pass {
          border: 1px solid #3366ff;
          color: #3366ff;
          margin-left: 25px;
        }
      }
    }
  }
}
</style>
